/**
 * erc-wa-origen.js
 * Marca imperceptible del origen del tráfico en el saludo del mensaje
 * prellenado de WhatsApp, para que quien atiende sepa de dónde viene la consulta:
 *
 *   Hola!!! / Hi!!!  → clic de pago (Google Ads, Bing Ads, utm_medium=cpc…)
 *   Hola!!  / Hi!!   → búsqueda orgánica (SEO)
 *   Hola!   / Hi!    → resto (directo, social orgánico, referidos, email)
 *
 * El idioma sale del saludo del propio mensaje y, si no hay saludo, del
 * lang del <html> (request.locale.iso_code).
 *
 * El origen se resuelve en cada pageview y se guarda en sessionStorage, así
 * sobrevive la navegación interna hasta que el usuario abre WhatsApp.
 * Atribución: gana el último clic NO directo de la sesión (igual que GA4).
 *
 * Reescribe el parámetro `text` de los enlaces wa.me / api.whatsapp.com /
 * web.whatsapp.com y del atributo data-wa-web (botón del diálogo QR), al cargar
 * y otra vez en el clic en fase de captura: así cubre los enlaces que inyecta
 * el filtro AJAX de colección y el QR se genera ya con la marca puesta.
 *
 * Depuración: window.ercWaOrigen → { origen, marcas, marcarUrl(url) }
 */
(function () {
  'use strict';

  var CLAVE = 'ercWaOrigen';
  var MARCAS = { ads: 3, seo: 2, otro: 1 };

  // OJO: fbclid NO cuenta como ads. Meta lo añade también a los clics orgánicos
  // de posts y bio, así que marcarlo como pago inflaría el conteo de Ads.
  var PARAMS_PAGO = ['gclid', 'gbraid', 'wbraid', 'dclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id'];
  var MEDIOS_PAGO = /^(cpc|ppc|cpm|cpv|cpa|paid|paid[-_]?search|paid[-_]?social|display|banner|retargeting|remarketing)$/i;
  var BUSCADORES = /(^|\.)(google|bing|duckduckgo|yahoo|ecosia|brave|qwant|yandex|baidu|naver|startpage)\./i;
  var PARAMS_CAMPANA = /[?&](utm_|gclid|gbraid|wbraid|dclid|msclkid|fbclid|ttclid|twclid|li_fat_id)/i;

  var ES_WA = /(?:wa\.me|whatsapp\.com|whatsapp:\/\/)/i;
  var SALUDO = /^\s*¡?\s*(hola|hi|hey|hello|buenas)\b[\s,.!¡…-]*/i;
  var SALUDO_EN = /^(hi|hey|hello)$/i;

  function leer() {
    try { return sessionStorage.getItem(CLAVE); } catch (e) { return null; }
  }

  function guardar(valor) {
    try { sessionStorage.setItem(CLAVE, valor); } catch (e) { /* modo privado */ }
  }

  function hostReferrer() {
    if (!document.referrer) return '';
    try { return new URL(document.referrer).hostname; } catch (e) { return ''; }
  }

  function detectar() {
    var qs;
    try { qs = new URLSearchParams(window.location.search); } catch (e) { qs = null; }

    function param(clave) {
      return qs ? (qs.get(clave) || '') : '';
    }

    var dePago = PARAMS_PAGO.some(function (clave) { return param(clave) !== ''; });
    var medio = param('utm_medium');
    if (dePago || MEDIOS_PAGO.test(medio)) return 'ads';
    if (medio.toLowerCase() === 'organic') return 'seo';

    // utm propios (email, colaboraciones), fbclid: señal real, pero no ads ni seo.
    if (PARAMS_CAMPANA.test(window.location.search)) return 'otro';

    var ref = hostReferrer();
    if (ref && ref !== window.location.hostname) {
      return BUSCADORES.test(ref) ? 'seo' : 'otro';
    }
    if (ref) return null; // navegación interna: conserva lo ya detectado

    // Sin referrer ni parámetros = directo: no pisa un origen anterior de la sesión.
    return leer() ? null : 'otro';
  }

  var detectado = detectar();
  if (detectado) guardar(detectado);

  var origen = leer() || 'otro';
  var marcas = MARCAS[origen] || 1;
  var signos = new Array(marcas + 1).join('!');

  // Normaliza cualquier saludo al canónico del idioma: Hola (ES) / Hi (EN).
  function saludo(palabra) {
    if (palabra) return SALUDO_EN.test(palabra) ? 'Hi' : 'Hola';
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return lang.indexOf('en') === 0 ? 'Hi' : 'Hola';
  }

  function marcarTexto(texto) {
    var coincide = texto.match(SALUDO);
    var base = saludo(coincide ? coincide[1] : '') + signos;
    var salida = coincide ? texto.replace(SALUDO, base + ' ') : base + ' ' + texto;
    return salida.replace(/\s+$/, '');
  }

  function marcarUrl(url) {
    if (!url || !ES_WA.test(url)) return url;

    var corte = url.indexOf('#');
    var base = corte === -1 ? url : url.slice(0, corte);
    var hash = corte === -1 ? '' : url.slice(corte);
    var texto = /([?&])text=([^&]*)/;

    if (texto.test(base)) {
      base = base.replace(texto, function (todo, separador, valor) {
        var actual;
        try {
          actual = decodeURIComponent(valor.replace(/\+/g, ' '));
        } catch (e) {
          actual = valor;
        }
        return separador + 'text=' + encodeURIComponent(marcarTexto(actual));
      });
    } else {
      base += (base.indexOf('?') === -1 ? '?' : '&') + 'text=' + encodeURIComponent(marcarTexto(''));
    }

    return base + hash;
  }

  function marcarEnlace(nodo) {
    if (!nodo || !nodo.getAttribute) return;
    ['href', 'data-wa-web'].forEach(function (attr) {
      var valor = nodo.getAttribute(attr);
      if (!valor) return;
      var nuevo = marcarUrl(valor);
      if (nuevo !== valor) nodo.setAttribute(attr, nuevo);
    });
  }

  function barrer(raiz) {
    var nodos = (raiz || document).querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"], [data-wa-web]');
    Array.prototype.forEach.call(nodos, marcarEnlace);
  }

  // Captura: corre antes que los handlers de los diálogos QR, que leen el href
  // en el momento del clic para pintar el código y el botón "abrir WhatsApp".
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    marcarEnlace(e.target.closest('a[href], [data-wa-web]'));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { barrer(); });
  } else {
    barrer();
  }

  window.ercWaOrigen = { origen: origen, marcas: marcas, marcarUrl: marcarUrl };
})();
